export const PRACTICE_ACTIVITIES = [
  {
    "_id": "6976a2016cb884ff5deae4b9", //mock id
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/The floor is wet.webp", matchingPath: "/units/land_nature/audio/Mitcisik nisabawe.m4a"},
      {path: "/units/land_nature/images/dry.webp", matchingPath: "/units/land_nature/audio/Pate together.m4a"},
    ],
    "audio": [
      {path: "/units/land_nature/audio/Pate together.m4a", matchingPath: "/units/land_nature/images/dry.webp"},
      {path: "/units/land_nature/audio/Mitcisik nisabawe.m4a", matchingPath: "/units/land_nature/images/The floor is wet.webp"},
    ],
    "lesson_type": "practice",
    "id": "696a8f0d7bbf3e4de4b8dc88",  //mock id
    "status": "none",
    "active": true,
    "order": 7,
    "activity_type": "MatchingPairs",
  },
  {
    "_id": "6976a2016cb884ff1deae4b9", //mock id
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/The wind is strong.webp", matchingPath: "/units/land_nature/audio/Mickwenowe (together).m4a"},
      {path: "/units/land_nature/images/wet.webp", matchingPath: "/units/land_nature/audio/Mitcisik nisabawe.m4a"},
      {path: "/units/land_nature/images/The sky is blue.webp", matchingPath: "/units/land_nature/audio/Micokon (together).m4a"},
    ],
    "audio": [
      {path: "/units/land_nature/audio/Micokon (together).m4a", matchingPath: "/units/land_nature/images/The sky is blue.webp"},
      {path: "/units/land_nature/audio/Mickwenowe (together).m4a", matchingPath: "/units/land_nature/images/The wind is strong.webp"},
      {path: "/units/land_nature/audio/Mitcisik nisabawe.m4a", matchingPath: "/units/land_nature/images/wet.webp"},
    ],
    "lesson_type": "practice",
    "id": "696a8f0d7bbf3e4de1b8dc88",  //mock id
    "status": "none",
    "active": true,
    "order": 7,
    "activity_type": "MatchingPairs",
  },
  {
    "_id": "6976a2016cb884ff5deae4b2",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/It's raining.webp",  correct: true},
      {path: "/units/land_nature/images/The snow is falling.webp"}
    ],
    "audio": [{path: "/units/land_nature/audio/Ki-mi-on.m4a"}],
    "lesson_type": "practice",
    "id": "696a66c07bbf3e4de4b8dc5a",
    "status": "none",
    "active": true,
    "order": 1,
    "activity_type": "ChooseImage",
  },
  {
    "_id": "6976a2016cb884ff5deae4b3",
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/The snow is falling.webp", correct: true},
      {path: "/units/land_nature/images/The wind is strong.webp"},
    ],
    "audio": [{path: "/units/land_nature/audio/Sokpin together.m4a"}],
    "lesson_type": "practice",
    "id": "696a8f0d7bbf3e4de4b8dc82",
    "status": "none",
    "active": true,
    "order": 2,
    "activity_type": "ChooseImage",
  },
  {
    "_id": "6976a2016cb884ff5deae4b4", //mock id
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/cold.webp"}
    ],
    "audio": [
      {path: "/units/land_nature/audio/Ki-si-na.m4a", correct: true},
      {path: "/units/land_nature/audio/Kijede together.m4a"}
    ],
    "lesson_type": "practice",
    "id": "696a8f0d7bbf3e4de4b8dc83",  //mock id
    "status": "none",
    "active": true,
    "order": 3,
    "activity_type": "ChooseAudio",
  },
  {
    "_id": "6976a2016cb884ff5deae4b5", //mock id
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/The wind is strong.webp"}
    ],
    "audio": [
      {path: "/units/land_nature/audio/Mickwenowe (together).m4a", correct: true},
      {path: "/units/land_nature/audio/Sokpin together.m4a"}
    ],
    "lesson_type": "practice",
    "id": "696a8f0d7bbf3e4de4b8dc84",  //mock id
    "status": "none",
    "active": true,
    "order": 4,
    "activity_type": "ChooseAudio",
  },
  {
    "_id": "6976a2016cb884ff5deae4b6", //mock id
    "topic": "Land & Nature",
    "question": "",
    "answer": "true",
    "image": [
      {path: "/units/land_nature/images/cold.webp"}
    ],
    "audio": [
      {path: "/units/land_nature/audio/Ki-si-na.m4a"}
    ],
    "lesson_type": "practice",
    "id": "696a8f0d7bbf3e4de4b8dc85",  //mock id
    "status": "none",
    "active": true,
    "order": 5,
    "activity_type": "TrueFalse",
  },
  {
    "_id": "6976a2016cb884ff5deae4b8", //mock id
    "topic": "Land & Nature",
    "question": "",
    "answer": false,
    "image": [
      {path: "/units/land_nature/images/The sun is shining.webp"}
    ],
    "audio": [
      {path: "/units/land_nature/audio/Sok-pin.m4a"},
      {path: "/units/land_nature/audio/Kijede together.m4a", correct: true},
    ],
    "lesson_type": "practice",
    "id": "696a8f0d7bbf3e4de4b8dc87",  //mock id
    "status": "none",
    "active": true,
    "order": 6,
    "activity_type": "ChooseAudio",
  },
]
